export function parseEmail(email: string) {
  const parsedEmail = email.trim();

  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  if (emailRegex.test(parsedEmail)) {
    return parsedEmail;
  }
  return "";
}

export function resolveSignInType(text: string) {
  const trimmedText = text.replace(/ /g, "");

  console.log(trimmedText);
  if (trimmedText.indexOf("@") != -1) {
    return "email";
  } else return "phone";
}
